module.exports = __webpack_public_path__ + "static/media/bath.140a4498.svg";